module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('section', {
    staticStyle: {
      "height": "auto"
    },
    style: ({
      backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.78), rgba(0, 0, 0, 0.48)), url(' + _vm.set_gallery_banner_image + ')'
    }),
    attrs: {
      "id": "banner"
    }
  }, [_c('div', {
    staticClass: "gw-info-wrap"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 gw-info-banner-img "
  }, [_c('img', {
    staticClass: "rounded",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "object-fit": "cover"
    },
    attrs: {
      "src": _vm.sellpoint.business_banner_image
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-md-offset-2 gw-about"
  }, [_c('h1', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Policy")]), _vm._v(" "), (_vm.sellpoint.business_policy != 'None provided yet') ? _c('p', {
    staticStyle: {
      "white-space": "pre-line",
      "text-align": "left"
    }
  }, [_vm._v(_vm._s(_vm.sellpoint.business_policy))]) : _vm._e()])]), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 gw-info"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48da3f94"}!./src/pages/Policy/template.html
// module id = 195
// module chunks = 1